import React from 'react';

import { Typography } from '@vtblife/uikit';

import classname from '@search/classname/src';

import { NewBuildingCardQueryResponse } from '../../../../common/components/NewBuildingCard';

import './styles.css';

interface IProps {
    newBuildingTitle: NewBuildingCardQueryResponse['newBuilding']['title']['nominative'];
}

const cn = classname.bind(null, 'NewBuildingCardHeading');

const NewBuildingCardHeading = ({
    newBuildingTitle
}: IProps) => (
    <div className={cn()}>
        <Typography
            tag='h1'
            variant='h1'
        >
            {newBuildingTitle}
        </Typography>
    </div>
);

export default React.memo(NewBuildingCardHeading);
